import React, { useState, useEffect } from 'react';
import {
  Table, Col, Spinner, Card, Tab, Tabs,
} from 'react-bootstrap';
import axios from 'axios';
import { Content } from '../styles';
import Navbar from '../../../../components/Navbar';
import Header from '../../../../components/Header';
import { Loader } from '../../../Superadmin/TambahAdmin/styles';
import Pengajuan from './pengajuan';
import config from '../../../../config';

const DaftarApproval = () => {
  const [loading, setLoading] = useState(false);
  const [datas, setDatas] = useState([]);
  const [status, setStatus] = useState('menunggu');

  useEffect(() => {
    setLoading(true);
    axios.get(`${config.API_BASE_URL}api/pengajuan_kuliah_umum/?status=${status}`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then(
      ({ data }) => {
        const simplifyData = data.map((
          (content) => (
            {
              nama: content.mahasiswa.user.name,
              namaKegiatan: content.kum_id.nama_kegiatan,
              url: `detail/${content.id}`,
              status: content.status,
            }
          )
        ));
        setDatas(simplifyData);
      },
    );
    setLoading(false);
  }, [status]);

  if (loading) {
    return (
      <Loader>
        <Spinner animation="border" />
      </Loader>
    );
  }

  return (
    <>
      <Navbar />
      <Header />
      <Content className={Content}>
        <Card>
          <Card.Header>
            <h1 className="text-center font-32 mb-4">
              Approval Pengajuan Pengadaan Kegiataan Kuliah Umum
            </h1>
          </Card.Header>
          <Card.Body>
            <Col md={{ span: 8, offset: 2 }}>
              <Tabs
                className="tabkum nav-fill font-20"
                id="controlled-tab"
                data-testid="date"
                activeState={status}
                onSelect={(k) => setStatus(k)}
                style={{ margin: '0' }}
              >
                <Tab eventKey="menunggu" title="Menunggu Persetujuan" />
                <Tab eventKey="disetujui" title="Disetujui" />
                <Tab eventKey="ditolak" title="Ditolak" />
                <Tab eventKey="sukses" title="Sukses" />
              </Tabs>
              <Table striped bordered hover className="text-center font-20">
                <thead>
                  <tr>
                    <th> No </th>
                    <th> Nama Pengaju </th>
                    <th> Nama Kegiatan </th>
                    <th> Detail </th>
                  </tr>
                </thead>
                <tbody>
                  {datas.map((
                    (data, i) => (
                      <Pengajuan
                        number={i + 1}
                        nama={data.nama}
                        namaKegiatan={data.namaKegiatan}
                        url={data.url}
                      />
                    )
                  ))}
                </tbody>
              </Table>
            </Col>
          </Card.Body>
        </Card>
      </Content>
    </>
  );
};

export default DaftarApproval;
